export default __webpack_public_path__ + "assets/img/category-item08.png";